<div class="track-in-cart">
  <div class="track-in-cart__track-descr">
    <bmcore-track-descr
      (closeCartPopupEvent)="closeCartPopupEvent()"
      [fixedBeat]="track"
      [parentComponent]="'track-in-cart-popUp'"
      [appType]="appType"
    >
    </bmcore-track-descr>
  </div>

  <bmcore-track-section-in-cart
    class="track-in-cart__section-in-cart"
    [ngClass]="{ 'track-in-cart__section-in-cart--unavailable': !track.isOK }"
    [track]="track"
    [parentComponent]="'track-in-cart-popUp'"
  >
  </bmcore-track-section-in-cart>
</div>
